$(function () {

    $('.dateInput .form-control').on('focus', function () {
        $(this).closest('.dateInput').addClass('active');
    });

    $('.dateInput .form-control').on('focusout', function () {
        $(this).closest('.dateInput').removeClass('active');
    });
})